import React from 'react';
import PropTypes from 'prop-types';

import RoundedButton from './RoundedButton';
import Spinner from './Spinner';

import s from './SpinButton.scss';

function SpinButton({ children, className, showSpinner, sleek, ...buttonProps }) {
  if (showSpinner) {
    return (
      <div className={`${className} ${s.wrapper}`}>
        <Spinner className={sleek ? s.sleek_spinner : ''} />
      </div>
    );
  }

  return (
    <RoundedButton className={className} sleek={sleek} {...buttonProps}>
      { children }
    </RoundedButton>
  );
}

SpinButton.propTypes = {
  ...RoundedButton.propTypes,
  showSpinner: PropTypes.bool
};

SpinButton.defaultProps = {
  className: '', // eslint-disable-line
  showSpinner: false
};

export default SpinButton;
